export default __webpack_public_path__ + "static/media/add.02a5b324.svg";